import { ApiService } from './../api-service.interface';
import { EspecieVeiculo } from '@tivic-team/manager-ts/dist/fta';
import { LoaderService } from 'app/services/loader.service';
import { EspecieVeiculoController } from './../../controllers/fta/especieveiculo.controller';
import { EspecieVeiculoSearch } from './especieveiculo.search';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EspecieVeiculoService implements ApiService<EspecieVeiculo> {

  constructor(private _especieVeiculoController: EspecieVeiculoController, private _loaderService: LoaderService) {}

  find(search?: EspecieVeiculoSearch): Promise<EspecieVeiculo[]> {
    this._loaderService.show();
    return this._especieVeiculoController.find((search && search.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  get(id: number): Promise<EspecieVeiculo> {
    this._loaderService.show();
    return this._especieVeiculoController.get(id).finally(() => this._loaderService.hide());
  }

  create(entity: EspecieVeiculo): Promise<EspecieVeiculo> {
    this._loaderService.show();
    return this._especieVeiculoController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: EspecieVeiculo):  Promise<EspecieVeiculo> {
    this._loaderService.show();
    return this._especieVeiculoController.update(entity).finally(() => this._loaderService.hide());
  }

  save(especieVeiculo: EspecieVeiculo): Promise<EspecieVeiculo> {
    this._loaderService.show();

    if (especieVeiculo.cdEspecie && especieVeiculo.cdEspecie > 0) {
        return this._especieVeiculoController.update(especieVeiculo).finally(() => this._loaderService.hide());
    } else {
        return this._especieVeiculoController.create(especieVeiculo).finally(() => this._loaderService.hide());
    }
  }

}
